function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.62637 17.4945L2.08146 2.34805C2.0494 2.21108 2.19261 2.09948 2.3176 2.16403L31.7164 17.3481C31.8354 17.4095 31.8354 17.5795 31.7164 17.641L2.3176 32.825C2.19261 32.8895 2.0494 32.7779 2.08146 32.641L5.62637 17.4945Z",
  stroke: "white",
  strokeWidth: 3.64577
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.6815 16.8352H5.79138C5.51827 16.8352 5.29688 17.0566 5.29688 17.3297C5.29688 17.6028 5.51827 17.8242 5.79138 17.8242H15.6815C15.9546 17.8242 16.176 17.6028 16.176 17.3297C16.176 17.0566 15.9546 16.8352 15.6815 16.8352Z",
  fill: "white",
  stroke: "white",
  strokeWidth: 2.73432
});

var SvgSendArrow = function SvgSendArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSendArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/send_arrow.dfda7d02.svg";
export { ForwardRef as ReactComponent };